import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateUserEmailPreferences = (onSuccess) => {
  const queryClient = useQueryClient();

  const mutationFn = useApiRequest({
    url: "users/me/email-preferences",
    method: HttpMethod.Post,
  });

  return useMutation({
    mutationKey: ["update-user-email-preferences"],
    mutationFn: ({ groupId, enabled }) =>
      mutationFn({ data: { group_id: groupId, enabled } }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["user-email-preferences"],
        exact: true,
      });
      onSuccess?.();
    },
  });
};
